import setConversationStack from './conversation_stack'
import getConversationStack from '../getters/conversation_stack'
import updateConversationStatusAtStack from '../helpers/update_conversation_status_at_stack'

const updateConversationStack = (currentUserUid, conversationId, status, viewportType) => {
  return getConversationStack(currentUserUid)
    .then(updateConversationStatusAtStack.bind(null, conversationId, status))
    .then(setConversationStack.bind(null, currentUserUid, viewportType))
}

export default (currentUserUid, conversationId, status, viewportType) => {
  return updateConversationStack(currentUserUid, conversationId, status, viewportType)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/update_conversation_status.js
 **/